export interface MileageEffectiveBillRateDto {
  effectiveBillRate: number;
  tableRate: number;
  tableRateSource: string;
  totalMiles: number;
  minimumTripMiles?: number;
  billableMiles: number;
  uncappedOneWayAmount: number;
  capAmountEachWay?: number;
  capTierFromMiles?: number;
  capTierToMiles?: number;
  oneWayAmount: number;
  capApplied: boolean;
  hasMileageRule: boolean;
}
